import React, {Component} from 'react';

import moment from "moment";
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';

import Table from "../../components/Table/Table";

import {
    deepCopyObject,
    getYearsList,
    hasUserRight,
    invoiceTypesSelectData,
    setFields,
    fetchAllUserList,
    showAxiosError, changeNumberFormat
} from "../../helper/helper";
import {request} from "../../helper/APIUtils";

import MediaViewer from "../einvoice/MediaViewer";
import {UncontrolledTooltip} from 'reactstrap';
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import ExcelExporter from "../../components/ExcelExporter";
import * as headerContent from "../../constants/exportcontent";
import DefaultModal from "../invoice/DefaultModal";
import Alert from "react-s-alert";
import {validateField} from "../../common/validation";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import SendInvoiceMailModal from "../../components/mail/SendInvoiceMailModal";
import NavBarKS from "../../components/NavBarKS";
import StickButton from "../../components/StickButton";
import SquareButton from "../../components/SquareButton";
import ArchiveDropdownButton from "../../components/ArchiveDropdownButton";
import ExpenseNoteModal from "../expensenote/ExpenseNoteModal";
import Tagging from "../tag/Tagging";
import CopyModal from "../copyModal/CopyModal";
import {UserRightsEnum} from "../../helper/enums";
import {EntegratorConf, VirtualHost} from "../../constants";
import YearPicker from "../einvoice/YearPicker";
import PrintViewer from "../einvoice/PrintViewer";
import {showDateFilter, showExcelExport} from "../../helper/permission";
import HeaderSearch from "../../components/HeaderSearch";
import AreaSearch from "../../components/AreaSearch";

class NewExpenseNote extends Component {
    constructor(props) {
        super(props);

        let yearsList = getYearsList();
        this.state = {
            years: yearsList,
            year: yearsList[0],
            month:  new Date().getMonth(),
            url: null,
            mediaModal: false,
            sendBtnDisabled: false,
            manual: false,
            content: [],
            total: 0,
            loading: false,
            searching: false,
            searchQuery: undefined,
            page: 0,
            size: 10,
            selection: [],
            selectedInvoice: [],
            tagList: [],
            selectedAll: false,
            stateCodes: [],
            btnDisabled: false,
            isArchive: 0,
            customHeaders: null,
            cancelReason: "",
            cancelTime: "",
            sheetName: 'Gider Pusulalar',
            xlsUrl: '/newExpenseNote/exportXls',
            error: {},
            tagingOpen: false,
            expenseNoteDocumentUuid: [],
            showCopydModal: false,
            resourcePrefix: this.props.resourcePrefix,
            printModal:false,
            printLoading:false,
            searchOpen: false,
            userNameList: [],
            windowSize : window.matchMedia('(max-width: 1024px)'),
            disabledButtonLoading: false,
            loadingObj:{
                singlePdfLoading:false,
                lotsPdfLoading:false,
                singleLoadingXSLT:false,
                lotsLoadingXML:false,
                printPdf:false
            },
            multipleVkn: null,
            headerOptions:[],
            headerSearch:[],
            notInList: false,
            documentIds : [],
        };
        this.fetchData = this.fetchData.bind(this);
        this.downloadMedia = this.downloadMedia.bind(this);
        this.setMediaViewer = this.setMediaViewer.bind(this);
        this.toggleCheckboxChange = this.toggleCheckboxChange.bind(this);
        this.getTrStyles = this.getTrStyles.bind(this);
        this.setStatus = this.setStatus.bind(this);
        this.onChangeArchive = this.onChangeArchive.bind(this);
        this.archiveInvoiceTypesSelectData = this.archiveInvoiceTypesSelectData.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.cancelExpenseNote = this.cancelExpenseNote.bind(this);
        this.confirmCancelExpenseNote = this.confirmCancelExpenseNote.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.copyEditExpenseNote = this.copyEditExpenseNote.bind(this);
        this.invoiceStates = this.invoiceStates.bind(this);
        this.clearSelection = this.clearSelection.bind(this);
        this.setYear = this.setYear.bind(this);
        this.setMonth = this.setMonth.bind(this);
        this.exportXls = this.exportXls.bind(this);
        this.closeClick = this.closeClick.bind(this);
        this.getTaglist = this.getTaglist.bind(this);
        this.revertCancelExpenseNote = this.revertCancelExpenseNote.bind(this);
        this.confirmRevertCancelExpenseNote = this.confirmRevertCancelExpenseNote.bind(this);
        this._fetchToken = undefined;
        this.renderDateConfirmError = this.renderDateConfirmError.bind(this);
        this.checkDateValidity = this.checkDateValidity.bind(this);
        this.onChangeReason = this.onChangeReason.bind(this);
        this.cancelExpenseNoteFromViewer = this.cancelExpenseNoteFromViewer.bind(this);
        this.revertCancelExpenseNoteFromViewer = this.revertCancelExpenseNoteFromViewer.bind(this);
        this.createExpenseNoteFromViewer = this.createExpenseNoteFromViewer.bind(this);
        this.sendEmailFromViewer = this.sendEmailFromViewer.bind(this);
        this.createInitialDate = this.createInitialDate.bind(this);
        this.closePrintModal = this.closePrintModal.bind(this);
        this.detailSearchToggle = this.detailSearchToggle.bind(this);
        this.searchOptions = this.searchOptions.bind(this);
        this.handleSearchHeader = this.handleSearchHeader.bind(this);
        this.fetchWithDocumentIds = this.fetchWithDocumentIds.bind(this);
    }

    componentWillMount() {
        let self = this;
        let params = {
            url: `/eArchive/getCodes`,
            method: "post",
        };
        request(params)
            .then(response => {
                self.setState({stateCodes: response.data.stateCodes});
            })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    componentWillUnmount() {
        //cancel pending requests on page unload.
        if (typeof this._fetchToken !== typeof undefined) {
            this._fetchToken.cancel('unload')
        }
    }
    copyEditExpenseNote(item, type) {
        let self = this;
        let params = {
            url: `/expenseNoteTmp/copyEditExpenseNote`,
            method: 'post',
            data: {
                documentUuid: item.documentUuid,
                type: type
            }
        };

        Alert.info(item.documentId + " numarasına sahip pusula " + (type === "edit" ? "düzenleme" : "kopyalama") + " için kontrol ediliyor..", {
            position: 'top-right',
            effect: 'stackslide',
            timeout: 'none'
        });

        request(params)
            .then(function (response) {
                let expenseNote = response.data;
                Alert.closeAll();
                Alert.success("Pusula " + (type === "edit" ? "düzenleme" : "kopyalama") + " için hazırlandı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.props.history.push(`/createEditExpenseNote/${expenseNote.recordId}`)
            }).catch(function (error) {
            Alert.closeAll();
            showAxiosError(error);
        });
    }

    onChangeArchive(isArchive) {
        this.setState({isArchive: isArchive, page: 0, size: 10, manual: true});
    }

    setStatus(e, status, type) {
        let self = this;
        let year = this.state.year.value;
        let params = {
            url: `/newExpenseNote/setStatus/${year}/${status}/${type}`,
            method: "post",
            data: self.state.selection
        };
        self.setState({btnDisabled: true});
        request(params)
            .then(function (response) {
                if (type === "isArchive") {
                    self.setState({manual: true, btnDisabled: false});
                } else if (type === "allArchive") {
                    Alert.success(("Bütün e-gider pusulalar " + (status === 0 ? "arşivden çıkarıldı." : "arşive alındı.")), {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 3000
                    });
                    self.setState({manual: true, btnDisabled: false});
                } else {
                    self.setState({btnDisabled: false});
                }
            }).catch(function (error) {
            self.setState({loading: false, btnDisabled: false});
            showAxiosError(error);
        });
    }

    downloadMedia(item, type) {
        let self = this;
        const windowsize =this.state.windowSize;
        let params = {
            url: `/newExpenseNote/downloadMedia/${type}`,
            responseType: 'arraybuffer',
            method: "post",
            data: {
                documentUuid: item.documentUuid,
            }
        };
        if (type !== "xml"  && !(type.endsWith("pdf") && windowsize.matches))
            self.setState({mediaModal: true, title: item.documentId, selectedItem: item});

        request(params)
            .then(function (response) {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);
                if (type !== "xml") {
                    self.setState({url: url});
                } else {
                    let a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = item.documentId + "_" + item.documentUuid + ".xml";
                    a.click();
                }

                if( type=== 'pdf'){
                    if(windowsize.matches) {
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = url;
                        a.download = item.documentUuid + ".pdf";
                        a.click();
                    }
                }
            }).catch(function (error) {
            if (error.response === undefined) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            } else {
                let enc = new TextDecoder("utf-8");
                showAxiosError({message: enc.decode(error.response.data)});
            }
            self.setState({mediaModal: false, title: null});
        });
    }

    setMediaViewer() {
        this.setState({url: null, mediaModal: false});
    }

    fetchData(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=receivedDate,desc'
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let year = !self.state.year.value ? 2021 : self.state.year.value;
        let month = self.state.month;
        let isArchiveQuery = (self.state.isArchive === 2) ? '' : '&isArchive=' + (self.state.isArchive);
        let multipleVknTckn = !self.state.multipleVkn ? [] : self.state.multipleVkn.split(',');
        let headerSearch = !self.state.headerSearch ? '' : self.state.headerSearch;
        let notInList = self.state.notInList;
        let documentIds = !self.state.documentIds ? '' : self.state.documentIds;
        let params = {
            url: '/newExpenseNote/getExpenseNotesByYear?year=' + year + '&month=' + month + '&page=' + page + '&size=' +  size +'&multipleVkn=' + multipleVknTckn +'&headerSearch='+ headerSearch +
                '&notInList='+  notInList  + '&documentIds='+ documentIds + sortStr + isArchiveQuery + searchQuery,
            method: "get",
        };

        self.setState({loading: true, manual: self.manual === true ? false : self.manual, documentIds: []});
        self.props.reload(true);
        request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                    searching: false,
                    selectedAll: false,
                    selection: [],
                    selectedInvoice: [],
                    documentIds: []
                });
                self.props.reload(false);
            }).catch(function (error) {
            self.setState({loading: false, searching: false, documentIds: []});
            self.props.reload(false);
            showAxiosError(error);
        });
    }


    handleSearchHeader(headerSearch, notInList) {
        this.setState({
            headerSearch,
            notInList,
            searching: true,
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    fetchWithDocumentIds(documentIds) {
        this.setState({
            documentIds,
            searching: true,
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    searchOptions(){
        let self = this;
        let listData;
        let options;
        let year = !self.state.year.value ? 2019 : self.state.year.value;
        let month = showDateFilter(EntegratorConf.identifier)? self.state.month : 12;
        let params = {
            url: '/newExpenseNote/getHeaderOptions?year=' + year + '&month=' + month,
            method: "get"
        };
        request(params)
            .then(function (response) {
                listData = response.data;
                options = listData.map((a , index) => ({
                    value: a[0] ,
                    label: a[0] +" - " +a[1]
                }));
                self.setState({
                    headerOptions: options
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    isSelected(id) {
        return (this.state.selection.indexOf(id) !== -1);
    }

    getTrStyles(row) {
        return {backgroundColor: (this.isSelected(row.recordId) ? "#ffc" : "#f9f9f9")};
    }

    getTaglist() {
        let self = this;
        let type = 7;
        let params = {
            url: '/tag/searchTagUser?type=' + type,
            method: "get",
        };
        request(params)
            .then(response => {
                let tagList = response.data;
                let options = [];
                options.push({
                    value: null,
                    label: 'Tümü'
                })
                tagList.forEach(tag => {
                    options.push({value: tag.recordId + "", label: tag.tagName})
                });
                return self.setState({tagList: options});
            })
            .catch(function (error) {
                showAxiosError(error);
            });


    }

    toggleCheckboxChange(e, row, id) {
        let self = this;
        let checked = e.target.checked;
        let items = self.state.content;
        let selection = self.state.selection;
        let selectedInvoice = self.state.selectedInvoice;
        let expenseNoteDocumentUuid = self.state.expenseNoteDocumentUuid;
        if (row === "all") {
            let selection = [];
            let selectedInvoice = [];
            let expenseNoteDocumentUuid = [];
            if (checked) {
                items.forEach(item => {
                    selection.push(item[id]);
                    selectedInvoice.push(item);
                    expenseNoteDocumentUuid.push(item.documentUuid);
                });
            }
            self.setState({selection, selectedInvoice, expenseNoteDocumentUuid, selectedAll: checked});
        } else {
            let index = selection.indexOf(row[id]);
            let indexInvoice = selectedInvoice.indexOf(row);
            let indexDocumentUuid = expenseNoteDocumentUuid.indexOf(row.documentUuid);
            if (index >= 0) {
                selection = [
                    ...selection.slice(0, index),
                    ...selection.slice(index + 1)
                ];
                selectedInvoice = [
                    ...selectedInvoice.slice(0, indexInvoice),
                    ...selectedInvoice.slice(indexInvoice + 1)
                ];
                expenseNoteDocumentUuid = [
                    ...expenseNoteDocumentUuid.slice(0, indexDocumentUuid),
                    ...expenseNoteDocumentUuid.slice(indexDocumentUuid + 1)
                ];
            } else {
                selection.push(row[id]);
                selectedInvoice.push(row);
                expenseNoteDocumentUuid.push(row.documentUuid);
            }
            self.setState({
                selectedInvoice,
                expenseNoteDocumentUuid,
                selection,
                selectedAll: ((selection.length > 0) ? (selection.length === self.state.content.length) : false)
            });
        }
    }

    closeClick() {
        this.setState({tagingOpen: false});
        this.getTaglist();
    }

    downloadLink = (type) => {

        if (!this.state.disabledButtonLoading) {
            const disabledButtonLoading = true;
            this.setState({disabledButtonLoading})
            if (this.state.isCreditSufficient != true) {
                return;
            }
            let self = this;
            const recordIds = this.state.selection;

            let loadingObj = self.state.loadingObj;

            if (type === 'singlePdf') {
                loadingObj.singlePdfLoading = true;
            } else if (type === 'pdfZip') {
                loadingObj.lotsPdfLoading = true;
            } else if (type === 'gibTekPdf') {
                loadingObj.singleLoadingXSLT = true;
            } else if (type === 'xmlZip') {
                loadingObj.lotsLoadingXML = true;
            }

            self.setState({loadingObj});

            const year = this.state.year.value;
            const recordsString = recordIds.join(",");
            const params = {
                url: `/newExpenseNote/downloadSelected?year=${year}&records=${recordsString}&type=${type}`,
                responseType: 'arraybuffer',
                method: "post",
            }

            request(params).then((response) => {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);
                let tempLink = document.createElement('a');
                tempLink.href = url;
                let name = response.headers["content-disposition"].split("=");
                if (type === 'singlePdf') {
                    tempLink.setAttribute('download', name[1]);
                    loadingObj.singlePdfLoading = false;
                    this.setState({disabledButtonLoading: false})
                } else if (type === 'pdfZip') {
                    tempLink.setAttribute('download', name[1]);
                    loadingObj.lotsPdfLoading = false;
                    this.setState({disabledButtonLoading: false})
                } else if (type === 'gibTekPdf') {
                    tempLink.setAttribute('download', name[1]);
                    loadingObj.singleLoadingXSLT = false;
                    this.setState({disabledButtonLoading: false})
                } else if (type === 'xmlZip') {
                    tempLink.setAttribute('download', name[1]);
                    loadingObj.lotsLoadingXML = false;
                    this.setState({disabledButtonLoading: false})
                }
                tempLink.click();

                self.setState({loadingObj});
            }).catch((error) => {
                if (type === 'singlePdf') {
                    loadingObj.singlePdfLoading = false;
                    this.setState({disabledButtonLoading: false})
                } else if (type === 'pdfZip') {
                    loadingObj.lotsPdfLoading = false;
                    this.setState({disabledButtonLoading: false})
                } else if (type === 'gibTekPdf') {
                    loadingObj.singleLoadingXSLT = false;
                    this.setState({disabledButtonLoading: false})
                } else if (type === 'xmlZip') {
                    loadingObj.lotsLoadingXML = false;
                    this.setState({disabledButtonLoading: false})
                }
                if (error.response === undefined) {
                    showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
                } else {
                    let enc = new TextDecoder("utf-8");
                    showAxiosError({message: enc.decode(error.response.data)});
                }
                self.setState({printModal: false, printLoading: false});
            });
        }
    }

    print(type) {
        if (!this.state.disabledButtonLoading) {
            this.setState({disabledButtonLoading: true})
            if (this.state.isCreditSufficient != true) return false;
            let self = this;
            const year = this.state.year.value;
            const recordIds = this.state.selection;
            const recordsString = recordIds.join(",");
            const url = `/newExpenseNote/downloadSelected?year=${year}&records=${recordsString}&type=${type}`;
            const params = {
                url: url,
                responseType: 'arraybuffer',
                method: "post",
            }
            self.setState({printLoading: true});
            request(params).then((response) => {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);
                self.setState({url: url, printModal: true, printLoading: false},
                    () => self.fetchData(self.state.accessor,
                        self.state.direction,
                        self.state.page,
                        self.state.size)
                );
                this.setState({disabledButtonLoading: false})
            }).catch((error) => {
                console.log(error);
                if (error.response === undefined) {
                    showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
                } else {
                    let enc = new TextDecoder("utf-8");
                    showAxiosError({message: enc.decode(error.response.data)});
                }
                self.setState({printModal: false, printLoading: false});
                this.setState({disabledButtonLoading: false})
            });
        }
    }
    closePrintModal(){
        let self = this;
        self.setState({printModal:false,url:null})
    }

    archiveInvoiceTypesSelectData() {
        return invoiceTypesSelectData().filter(invoiceType => !["SGK"].includes(invoiceType.value));
    }

    invoiceStates() {

        return [
            {value: null, label: "Tümü"},
            {value: "1", label: "Hatasız"},
            {value: "3", label: "Hatalı"},
        ]
    }

    handleSearch(searchQuery, multipleVkn) {
        if(searchQuery.includes("documentIssueDate=0")){
            searchQuery = searchQuery.split("&")[1];
        }
        this.setState({
            searchQuery,
            searching: true,
            multipleVkn
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    cancelExpenseNote(item) {
        this.setState({showCancelModal: true, selectedItem: item});
    }

    revertCancelExpenseNote(item) {
        this.setState({showRevertCancelModal: true, selectedItem: item});
    }

    confirmCancelExpenseNote() {
        let self = this;
        let params = {
            url: `/newExpenseNote/cancelExpenseNote`,
            method: 'post',
            data: {
                cancelReason: self.state.cancelReason,
                cancelTime: self.state.cancelTime,
                documentUuid: self.state.selectedItem.documentUuid
            }
        };

        self.setState({cancelBtnDisabled: true});
        request(params)
            .then(function (response) {
                self.setState({
                    showCancelModal: false,
                    cancelBtnDisabled: false,
                    cancelReason: "",
                    cancelTime: "",
                    manual: true
                });
                Alert.success("İptal gönderim başarılı şekilde gerçekleştirildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch(function (error) {
            self.setState({cancelBtnDisabled: false});
            showAxiosError(error);
        });
    }

    confirmRevertCancelExpenseNote() {
        let self = this;
        let params = {
            url: `/newExpenseNote/revertCancelExpenseNote`,
            method: 'post',
            data: {
                documentUuid: self.state.selectedItem.documentUuid
            }
        };

        self.setState({cancelBtnDisabled: true});
        request(params)
            .then(function (response) {
                self.setState({
                    showRevertCancelModal: false,
                    cancelBtnDisabled: false,
                    manual: true
                });
                Alert.success("Pusula iptali başarılıyla geri alındı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch(function (error) {
            self.setState({cancelBtnDisabled: false});
            showAxiosError(error);
        });
    }

    clearSelection() {
        this.setState({
            selection: []
        })
    }

    onChangeValue(e) {
        let name = e.target.name;
        let value = e.target.value;
        if (!(typeof value === "string") || value === "") {
            if (name === "cancelTime") {
                if (value === "") {
                    this.setState({[name]: value});
                } else {
                    let datetime = value.format("YYYY-MM-DD HH:mm:ss");
                    this.setState({[name]: datetime});
                }
            }
        } else {
            if (name === "cancelReason") {
                this.setState({[name]: value});
            }
        }
    }

    onChangeReason(e) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({[name]: value});
    }

    validateField(e, custom) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = !!custom ? custom : validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    setYear(year) {
        let month;
        let date = new Date();
        if (year.value === date.getFullYear()) {
            month = date.getMonth();
        } else {
            month = 0;
        }

        this.setState({year, month,searchQuery: undefined}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size));
    }

    setMonth(month) {
        this.setState({month,searchQuery: undefined}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size));
    }

    async exportXls() {
        this.setState({buttonStyle: 'fas fa-spinner fa-spin'});
        let self = this;
        let data = self.arrangeDataSet('');
        let params = {
            url: '/newExpenseNote/exportXls', //TODO: self
            method: "post",
            responseType: 'arraybuffer',
            data: data,
        };
        self.setState({manual: self.manual === true ? false : self.manual});
        let download = await self.prepareSheetName();
        await request(params).then(function (response) {
            let blob = new Blob([response.data], {type: response.headers["content-type"]});
            let urlCreator = window.URL || window.webkitURL;
            let url = urlCreator.createObjectURL(blob);
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = download;
            a.click();
            self.setState({buttonStyle: null});
        }).catch(function (error) {
            self.setState({buttonStyle: null});
            showAxiosError(error);
        });
    }

    arrangeDataSet(type) {
        let dataSet = {};

        let selection = this.state.selection;
        let content = this.state.content;
        let selectedContent = [];

        if (type !== 'custom')
            content.map(con => {
                selection.map(sel => {
                    if (con.recordId === sel) {
                        selectedContent.push(con)
                    }
                })
            });

        dataSet.content = selectedContent;
        dataSet.headers = headerContent.eArchiveContent;

        dataSet.sheetName = 'e-Gider Pusulalar';
        dataSet.year = this.state.year.value;

        return dataSet;
    }

    async prepareSheetName() {
        let selection = deepCopyObject(this.state.selection);
        let payload = [];
        let sheetName = null;

        if ((selection && selection.length > 0)) {
            if (selection.length === 1) {
                payload.push(selection[0]);
                payload.push(null);
            } else {
                payload.push(selection[0]);
                payload.push(selection[selection.length - 1]);
            }

            let self = this;
            let rawCustomSheetNameUrl = 'newExpenseNote/findFirstAndLast';
            let customSheetNameUrl = (self.state.year !== undefined) ? `${rawCustomSheetNameUrl}?year=${self.state.year}` : rawCustomSheetNameUrl;
            let params = {
                url: customSheetNameUrl,
                method: "post",
                data: payload
            };
            self.setState({manual: self.manual === true ? false : self.manual});
            await request(params).then(function (response) {
                let result = response.data;
                if (result[1] === null) {
                    sheetName = 'e-Gider Pusulalar' + '-' + result[0].documentId + ' - (' + result[0].documentIssueDate + ')';
                } else {
                    sheetName = 'e-Gider Pusulalar' + '-' + result[1].documentId + ' - ' + result[0].documentId + ' - (' +
                        result[1].documentIssueDate + ' - ' + result[0].documentIssueDate + ')';
                }
            }).catch(function (error) {
                showAxiosError(error);
            });
        }

        return sheetName;
    }

    componentDidMount() {
        this.getTaglist();
        let isCreditSufficient = this.props.isCreditSufficient!=undefined ? this.props.isCreditSufficient:true;
        this.setState({btnDisabled:!isCreditSufficient,isCreditSufficient});
    }

    renderDateConfirmError() {
        let ControlDate = new Date();
        let ToDate = new Date();
        ToDate = moment();
        ControlDate = moment(this.state.cancelTime).format("DD-MM-YYYY HH:mm:ss");
        if (ControlDate !== "Invalid date" && Date.parse(moment(this.state.cancelTime)) > Date.parse(ToDate)) {
            Alert.error('Geçerli bir tarih giriniz: İptal tarihi, bugünün tarihinden ileri olamaz !', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        } else if (ControlDate === "Invalid date" || ControlDate === "" || ControlDate === null) {
            Alert.error('Geçerli bir tarih giriniz: Tarih alanı boş bırakılamaz veya harf girilemez!', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        } else {
            this.confirmCancelExpenseNote();
        }
    }


    checkDateValidity(current, name) {
        let start = Datetime.moment().subtract(0, 'day');

        if (name === 'cancelTime') {
            return current.isBefore(start);
        }
    }

    async cancelExpenseNoteFromViewer(item) {
        await this.setState({mediaModal: false});
        this.setState({showCancelModal: true, selectedItem: item});
    }

    async revertCancelExpenseNoteFromViewer(item) {
        await this.setState({mediaModal: false});
        this.setState({showRevertCancelModal: true, selectedItem: item});
    }

    async sendEmailFromViewer(item) {
        await this.setState({mediaModal: false});
        this.setState({selected: item, mailModal: true})
    }

    async createExpenseNoteFromViewer(item) {
        await this.setState({mediaModal: false});
        this.setState({
            documentUuid: item.documentUuid,
            expenseNoteModal: true,
        })
    }

    createInitialDate(){
        if(this.state.month<12)
        {
            return  new moment(this.state.year.value.toString() + '-' + (this.state.month +1).toString() + '-01')		}
        else {
            return undefined
        }
    }

    async detailSearchToggle(e) {
        let self = this;
        self.setState({searchOpen: !this.state.searchOpen})

        if (!this.state.searchOpen) {
            let userNameList = await fetchAllUserList();
            self.setState({userNameList});
        }
    }
    render() {
        const source = VirtualHost.conf.resourcePrefix;
        const isCreditSufficient = this.state.isCreditSufficient!=undefined?this.state.isCreditSufficient:true;

        const defaultHeaders = headerContent.expenseNoteContent;
        const loadingObj = this.state.loadingObj
        const columns = [
            {
                Header: (<input type="checkbox" checked={this.state.selectedAll}
                                onChange={(e) => this.toggleCheckboxChange(e, "all", "recordId")}/>),
                accessor: "recordId",
                selectType: "checkbox",
                sortable: false,
                Cell: (row, index) => (<input type="checkbox" checked={this.isSelected(row.recordId)}
                                              onChange={(e) => this.toggleCheckboxChange(e, row, "recordId", index)}/>)
            },
            {
                accessor: [{Header: <AreaSearch header="Doküman No" accessor="documentId" handleSearch={this.fetchWithDocumentIds}/>, accessor: "documentId"},
                    {Header: "ETTN", accessor: "documentUuid"}],
                title : "Doküman No",
                Cell: row => (row.documentId !== null ? (
                        <div style={{margin: 0}}><a style={{cursor: "pointer"}} onClick={() => {
                            if(isCreditSufficient){
                                this.downloadMedia(row, "pdf")
                            }
                        }}>{row.documentId}</a>
                            <br/> <TextOverFlowTooltip text={row.documentUuid}
                                                                                             maxLength={16}/></div>) :
                    <TextOverFlowTooltip text={row.documentUuid} maxLength={16}/>)
            },
            {
                accessor: [
                    {Header: "Pusula Tarihi", accessor: "documentIssueDate"},
                    {Header: "Alınma Tarihi", accessor: "receivedDate"}
                ],
                Cell: row => (
                    <div
                        style={{margin: 0}}>{moment(row.documentIssueDate).isValid() ? moment(row.documentIssueDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                        <br/> {moment(row.receivedDate).isValid() ? moment(row.receivedDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                    </div>)
            },
            {
                accessor: [
                    {Header:<HeaderSearch header= "Alıcı Unvan" accessor= "destinationTitle" options={this.state.headerOptions} onOpen={this.searchOptions} handleSearch={this.handleSearchHeader}/>, accessor: "destinationTitle"},
                    {Header: "VKN/TCKN", accessor: "destinationId"}
                ],
                Cell: row => (<div style={{margin: 0}}><TextOverFlowTooltip text={row.destinationTitle} maxLength={25}/>
                    <br/> {row.destinationId}</div>)
            },
            {
                accessor: [
                    {Header: "Mal.Hiz.Top.Tut.", accessor: "lineExtensionAmount"},
                    {Header: "Toplam İskonto", accessor: "allowanceTotalAmount"}
                ],
                Cell: row => (
                    <div style={{margin: 0}}>{(changeNumberFormat(row.lineExtensionAmount) || "")+" "+(row.currencyCode || "")}
                        <br/> {(changeNumberFormat(row.allowanceTotalAmount) || "") + " " + (row.currencyCode || "")}</div>)
            },
            {
                Header: "Toplam KDV",
                accessor: "",
                sortable: false,
                Cell: row => (<div><TextOverFlowTooltip text={row.kdvOranlar || "-"} maxLength={20}/></div>)
            },
            {
                accessor: [
                    {Header: "Ödenecek Tutar", accessor: "documentTotal"},
                    {Header: "VHTT", accessor: "taxExclusiveAmount"}
                ],
                Cell: row => (
                    <div style={{margin: 0}}>{(changeNumberFormat(row.documentTotal) || "")+ " " +(row.currencyCode || "") }
                        <br/> {(changeNumberFormat(row.taxExclusiveAmount) || "") + " " + (row.currencyCode || "")}
                    </div>)
            },
            {
                accessor: [
                    {Header: "Senaryo Türü", accessor: "documentProfile"},
                    {Header: "Pusula Türü", accessor: "invoiceTypeCode"}
                ],
                Cell: row => (<div style={{margin: 0}}>
                    {row.documentProfile}<br/>
                    {row.invoiceTypeCode}
                </div>)
            },
            {
                Header: "Doküman Durumu",
                accessor: "documentProfile",
                sortable: false,
                Cell: row => (<div style={{margin: 0}}>
                    {(row.processState === 100 && (row.processResult === 0 || row.processResult === 1)) ?
                        <p className="text-warning" style={{margin: 0}}>PUSULA İÇERİĞİ OKUNUYOR</p> :
                        <div style={{margin: 0}}>
                            {this.state.stateCodes instanceof Object && ((row.processState + "" + row.processResult) in this.state.stateCodes) &&
                            <p className={(this.state.stateCodes[row.processState + "" + row.processResult][1] === "F" ?
                                "text-danger" : this.state.stateCodes[row.processState + "" + row.processResult][1] === "P" ?
                                    "text-warning" : "text-success")}
                               id={"stateCode" + row.recordId}
                               style={{margin: 0}}>{this.state.stateCodes[row.processState + "" + row.processResult][0]}</p>
                            }
                            {row.resultExplanation && this.state.stateCodes instanceof Object && ((row.processState + "" + row.processResult) in this.state.stateCodes) &&
                            <UncontrolledTooltip placement="right" target={"stateCode" + row.recordId} delay={0}>
                                {row.resultExplanation}
                            </UncontrolledTooltip>
                            }
                            {row.cancelled === 1 &&
                            <p className="text-info" style={{margin: 0}} id={"cancelled" + row.recordId}>İPTAL
                                EDİLDİ</p>
                            }
                            {row.cancelled === 1 &&
                            <UncontrolledTooltip placement="right" target={"cancelled" + row.recordId} delay={0}>
                                {row.cancelReason + " / " + (moment(row.cancelDate).isValid() ? moment(row.cancelDate).format("DD-MM-YYYY HH:mm:ss") : '')}
                            </UncontrolledTooltip>
                            }
                        </div>
                    }
                </div>)
            },
            {
                Header: <TextOverFlowTooltip text="e-Posta Durumu" maxLength={8}/>,
                accessor: "emailSentDate",
                sortable: false,
                Cell: row => (<div style={{margin: 0}}>
                    {row.emailSent === 4 &&
                    <button className="btn btn-icon btn-neutral btn-md" id={"emailSentDate4" + row.recordId}
                            style={{backgroundColor: "inherit", color: "#dc3545", margin: 0}}>
                        <i className="fa fa-envelope"></i>
                    </button>
                    }
                    {row.emailSent === 4 &&
                    <UncontrolledTooltip placement="right" target={"emailSentDate4" + row.recordId} delay={0}>
                        {"Geçerli bir E-Posta adresi bulunamadı."}
                    </UncontrolledTooltip>
                    }
                    {row.emailSent === 0 &&
                    <button className="btn btn-icon btn-neutral btn-md" id={"emailSentDate0" + row.recordId}
                            style={{backgroundColor: "inherit", color: "#FFB236", margin: 0}}>
                        <i className="fa fa-envelope"></i>
                    </button>
                    }
                    {row.emailSent === 0 &&
                    <UncontrolledTooltip placement="right" target={"emailSentDate0" + row.recordId} delay={0}>
                        e-Posta gönderim bekliyor. {row.destinationEMail ? "(" + row.destinationEMail + ")" : ""}
                    </UncontrolledTooltip>
                    }
                    {row.emailSent === 1 &&
                    <button className="btn btn-icon btn-neutral btn-md" id={"emailSentDate1" + row.recordId}
                            style={{backgroundColor: "inherit", color: "#78d78f", margin: 0}}>
                        <i className="fa fa-envelope"></i>
                    </button>
                    }
                    {row.emailSent === 1 &&
                    <UncontrolledTooltip placement="right" target={"emailSentDate1" + row.recordId} delay={0}>
                        {(moment(row.emailSendDate).isValid() ? moment(row.emailSendDate).format("DD-MM-YYYY HH:mm:ss") : '')}
                        {' '} tarihinde e-Posta
                        gönderildi.{row.destinationEMail ? "(" + row.destinationEMail + ")" : ""}
                    </UncontrolledTooltip>
                    }
                    {row.emailSent === 3 &&
                    <button className="btn btn-icon btn-neutral btn-md" id={"emailSentDate3" + row.recordId}
                            style={{backgroundColor: "inherit", color: "#dc3545", margin: 0}}>
                        <i className="fa fa-envelope"></i>
                    </button>
                    }
                    {row.emailSent === 3 &&
                    <UncontrolledTooltip placement="right" target={"emailSentDate3" + row.recordId} delay={0}>
                        {row.resultExplanation || "e-Posta gönderilmedi."}. {row.destinationEMail ? "(" + row.destinationEMail + ")" : ""}
                    </UncontrolledTooltip>
                    }
                </div>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                width: "11%",
                sortable: false,
                Cell: item => (
                    <div className="btn-group">
                        <div className="dropdown">
                            <button className="MenuBtn2 listt btn btn-default" type="button"
                                    disabled={!isCreditSufficient}
                                    data-toggle="dropdown">Seçİnİz
                            </button>
                            <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + item.recordId}>
                                {this.state.stateCodes instanceof Object && ((item.processState + "" + item.processResult) in this.state.stateCodes) && this.state.stateCodes[item.processState + "" + item.processResult][1] === "F" &&
                                hasUserRight(UserRightsEnum.newExpenseNote.update, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.copyEditExpenseNote(item, "edit")}>
                                    <i className="fa fa-edit"/> Pusulayı Düzenle
                                </a>
                                }
                                {item.processState > 100 && hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.downloadMedia(item, this.state.windowSize.matches ? "html" : "pdfGIB", )}>
                                    <i className="fa fa-university"/> GİB XSLT ile Göster </a>
                                }
                                {item.processState > 100 && hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.downloadMedia(item, "html")}>
                                    <i className="fa fa-eye"/> Pusulayı Göster</a>
                                }
                                {hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.downloadMedia(item, "xml")}>
                                    <i className="fa fa-file-code-o"/> Pusula XML İndir</a>
                                }
                                {item.processState > 100 && hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.downloadMedia(item, "pdf")}>
                                    <i className="fa fa-file-pdf-o"/> Pusula PDF İndir</a>
                                }
                                {item.cancelled !== 1 && !(item.processState < 140 && item.processResult === 3) &&
                                hasUserRight(UserRightsEnum.newExpenseNote.update, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.cancelExpenseNote(item)}>
                                    <i className="fa fa-ban"/>Pusulayı İptal Et
                                </a>
                                }
                                {item.cancelled === 1 && item.cancelReportNo === null &&
                                hasUserRight(UserRightsEnum.newExpenseNote.update, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.revertCancelExpenseNote(item)}>
                                    <i className="fa fa-ban"/>Pusula İptalini Geri Al
                                </a>
                                }
                                {hasUserRight(UserRightsEnum.newExpenseNote.create, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.copyEditExpenseNote(item, "copy")}><i
                                    className="fa fa-clone"/>Pusula Kopyala</a>
                                }
                                {item.processState > 110 && hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item"
                                   onClick={() => this.setState({selected: item, mailModal: true})}><i
                                    className="fa fa-envelope"/> e-Posta Gönder</a>
                                }
                            </div>
                        </div>
                    </div>
                )
            }
        ];

        const vegaColumns = [
            {
                Header: (<input type="checkbox" checked={this.state.selectedAll}
                                onChange={(e) => this.toggleCheckboxChange(e, "all", "recordId")}/>),
                accessor: "recordId",
                selectType: "checkbox",
                sortable: false,
                Cell: (row, index) => (<input type="checkbox" checked={this.isSelected(row.recordId)}
                                              onChange={(e) => this.toggleCheckboxChange(e, row, "recordId", index)}/>)
            },
            {
                accessor: [
                    {Header: "Alıcı Unvan", accessor: "destinationTitle"},
                    {Header: "VKN/TCKN", accessor: "destinationId"}
                ],
                Cell: row => (<div style={{margin: 0}}><TextOverFlowTooltip text={row.destinationTitle} maxLength={25}/>
                    <br/> {row.destinationId}</div>)
            },
            {
                accessor: [
                    {Header: "Doküman No", accessor: "documentId"},
                    {Header: "ETTN", accessor: "documentUuid"}
                ],
                Cell: row => (row.documentId !== null ? (
                        <div style={{margin: 0}}>{row.documentId} <br/> <TextOverFlowTooltip text={row.documentUuid}
                                                                                             maxLength={16}/></div>) :
                    <TextOverFlowTooltip text={row.documentUuid} maxLength={16}/>)
            },
            {
                accessor: [
                    {Header: "Pusula Tarihi", accessor: "documentIssueDate"},
                    {Header: "Alınma Tarihi", accessor: "receivedDate"}
                ],
                Cell: row => (
                    <div
                        style={{margin: 0}}>{moment(row.documentIssueDate).isValid() ? moment(row.documentIssueDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                        <br/> {moment(row.receivedDate).isValid() ? moment(row.receivedDate).format("DD-MM-YYYY HH:mm:ss") : ''}
                    </div>)
            },
            {
                accessor: [
                    {Header: "Senaryo Türü", accessor: "documentProfile"},
                    {Header: "Pusula Türü", accessor: "invoiceTypeCode"}
                ],
                Cell: row => (<div style={{margin: 0}}>
                    {row.documentProfile}<br/>
                    {row.invoiceTypeCode}
                </div>)
            },
            {
                Header: "Doküman Durumu",
                accessor: "documentProfile",
                sortable: false,
                Cell: row => (<div style={{margin: 0}}>
                    {(row.processState === 100 && (row.processResult === 0 || row.processResult === 1)) ?
                        <p className="text-warning" style={{margin: 0}}>PUSULA İÇERİĞİ OKUNUYOR</p> :
                        <div style={{margin: 0}}>
                            {this.state.stateCodes instanceof Object && ((row.processState + "" + row.processResult) in this.state.stateCodes) &&
                            <p className={(this.state.stateCodes[row.processState + "" + row.processResult][1] === "F" ?
                                "text-danger" : this.state.stateCodes[row.processState + "" + row.processResult][1] === "P" ?
                                    "text-warning" : "text-success")}
                               id={"stateCode" + row.recordId}
                               style={{margin: 0}}>{this.state.stateCodes[row.processState + "" + row.processResult][0]}</p>
                            }
                            {row.resultExplanation && this.state.stateCodes instanceof Object && ((row.processState + "" + row.processResult) in this.state.stateCodes) &&
                            <UncontrolledTooltip placement="right" target={"stateCode" + row.recordId} delay={0}>
                                {row.resultExplanation}
                            </UncontrolledTooltip>
                            }
                            {row.cancelled === 1 &&
                            <p className="text-info" style={{margin: 0}} id={"cancelled" + row.recordId}>İPTAL
                                EDİLDİ</p>
                            }
                            {row.cancelled === 1 &&
                            <UncontrolledTooltip placement="right" target={"cancelled" + row.recordId} delay={0}>
                                {row.cancelReason + " / " + (moment(row.cancelDate).isValid() ? moment(row.cancelDate).format("DD-MM-YYYY HH:mm:ss") : '')}
                            </UncontrolledTooltip>
                            }
                        </div>
                    }
                </div>)
            },
            {
                accessor: [
                    {Header: "Mal.Hiz.Top.Tut.", accessor: "lineExtensionAmount"},
                    {Header: "Toplam İskonto", accessor: "allowanceTotalAmount"}
                ],
                Cell: row => (
                    <div style={{margin: 0}}>{(row.lineExtensionAmount || "")}
                        <br/> {(row.allowanceTotalAmount || "") + " " + (row.currencyCode || "")}</div>)
            },
            {
                Header: "Toplam KDV",
                accessor: "",
                sortable: false,
                Cell: row => (<div><TextOverFlowTooltip text={row.kdvOranlar || "-"} maxLength={20}/></div>)
            },
            {
                accessor: [
                    {Header: "Ödenecek Tutar", accessor: "documentTotal"},
                    {Header: "VHTT", accessor: "taxExclusiveAmount"}
                ],
                Cell: row => (
                    <div style={{margin: 0}}>{(row.invoiceTotal || "")}<br/> {(row.taxExclusiveAmount || "") + " " + (row.currencyCode || "")}
                    </div>)
            },
            {
                Header: <TextOverFlowTooltip text="e-Posta Durumu" maxLength={8}/>,
                accessor: "emailSentDate",
                sortable: false,
                Cell: row => (<div style={{margin: 0}}>
                    {row.emailSent === 4 &&
                    <button className="btn btn-icon btn-neutral btn-md" id={"emailSentDate4" + row.recordId}
                            style={{backgroundColor: "inherit", color: "#dc3545", margin: 0}}>
                        <i className="fa fa-envelope"></i>
                    </button>
                    }
                    {row.emailSent === 4 &&
                    <UncontrolledTooltip placement="right" target={"emailSentDate4" + row.recordId} delay={0}>
                        {"Geçerli bir E-Posta adresi bulunamadı."}
                    </UncontrolledTooltip>
                    }
                    {row.emailSent === 0 &&
                    <button className="btn btn-icon btn-neutral btn-md" id={"emailSentDate0" + row.recordId}
                            style={{backgroundColor: "inherit", color: "#FFB236", margin: 0}}>
                        <i className="fa fa-envelope"></i>
                    </button>
                    }
                    {row.emailSent === 0 &&
                    <UncontrolledTooltip placement="right" target={"emailSentDate0" + row.recordId} delay={0}>
                        e-Posta gönderim bekliyor. {row.destinationEMail ? "(" + row.destinationEMail + ")" : ""}
                    </UncontrolledTooltip>
                    }
                    {row.emailSent === 1 &&
                    <button className="btn btn-icon btn-neutral btn-md" id={"emailSentDate1" + row.recordId}
                            style={{backgroundColor: "inherit", color: "#78d78f", margin: 0}}>
                        <i className="fa fa-envelope"></i>
                    </button>
                    }
                    {row.emailSent === 1 &&
                    <UncontrolledTooltip placement="right" target={"emailSentDate1" + row.recordId} delay={0}>
                        {(moment(row.emailSendDate).isValid() ? moment(row.emailSendDate).format("DD-MM-YYYY HH:mm:ss") : '')}
                        {' '} tarihinde e-Posta
                        gönderildi.{row.destinationEMail ? "(" + row.destinationEMail + ")" : ""}
                    </UncontrolledTooltip>
                    }
                    {row.emailSent === 3 &&
                    <button className="btn btn-icon btn-neutral btn-md" id={"emailSentDate3" + row.recordId}
                            style={{backgroundColor: "inherit", color: "#dc3545", margin: 0}}>
                        <i className="fa fa-envelope"></i>
                    </button>
                    }
                    {row.emailSent === 3 &&
                    <UncontrolledTooltip placement="right" target={"emailSentDate3" + row.recordId} delay={0}>
                        {row.resultExplanation || "e-Posta gönderilmedi."}. {row.destinationEMail ? "(" + row.destinationEMail + ")" : ""}
                    </UncontrolledTooltip>
                    }
                </div>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                width: "11%",
                sortable: false,
                Cell: item => (
                    <div className="btn-group">
                        <div className="dropdown">
                            <button className="MenuBtn2 listt btn btn-default" type="button"
                                    data-toggle="dropdown">Seçİnİz
                            </button>
                            <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + item.recordId}>
                                {this.state.stateCodes instanceof Object && ((item.processState + "" + item.processResult) in this.state.stateCodes) && this.state.stateCodes[item.processState + "" + item.processResult][1] === "F" &&
                                hasUserRight(UserRightsEnum.newExpenseNote.update, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.copyEditExpenseNote(item, "edit")}>
                                    <i className="fa fa-edit"/> Pusulayı Düzenle
                                </a>
                                }
                                {item.processState > 100 && hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.downloadMedia(item, "pdfGIB")}>
                                    <i className="fa fa-university"/> GİB XSLT ile Göster </a>
                                }
                                {item.processState > 100 && hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.downloadMedia(item, "html")}>
                                    <i className="fa fa-eye"/> Pusulayı Göster</a>
                                }
                                {hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.downloadMedia(item, "xml")}>
                                    <i className="fa fa-file-code-o"/> Pusula XML İndir</a>
                                }
                                {item.processState > 100 && hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.downloadMedia(item, "pdf")}>
                                    <i className="fa fa-file-pdf-o"/> Pusula PDF İndir</a>
                                }
                                {item.cancelled !== 1 && !(item.processState < 140 && item.processResult === 3) &&
                                hasUserRight(UserRightsEnum.newExpenseNote.update, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.cancelExpenseNote(item)}>
                                    <i className="fa fa-ban"/>Pusulayı İptal Et
                                </a>
                                }
                                {item.cancelled === 1 && item.cancelReportNo === null &&
                                hasUserRight(UserRightsEnum.newExpenseNote.update, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.revertCancelExpenseNote(item)}>
                                    <i className="fa fa-ban"/>Pusula İptalini Geri Al
                                </a>
                                }
                                {hasUserRight(UserRightsEnum.newExpenseNote.create, this.props.currentUser) &&
                                <a className="dropdown-item" onClick={() => this.copyEditExpenseNote(item, "copy")}><i
                                    className="fa fa-clone"/>Pusula Kopyala</a>
                                }
                                {item.processState > 110 && hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) &&
                                <a className="dropdown-item"
                                   onClick={() => this.setState({selected: item, mailModal: true})}><i
                                    className="fa fa-envelope"/> e-Posta Gönder</a>
                                }
                            </div>
                        </div>
                    </div>
                )
            }
        ];

        const fields = [
            {
                label: "Pusula No",
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: "Pusula ETTN",
                accessor: "documentUuid",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı Unvan",
                accessor: "destinationTitle",
                type: "text",
                operator: "=",
            },
            {
                label: "Alıcı VKN/TCKN",
                accessor: "destinationIds",
                type: "textArea",
                operator: "=",
                initialValue:this.props.initialSearchQuery.value
            },
            {
                label: "Alınma Tarihi (Başlangıç)",
                accessor: "min_receivedDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Alınma Tarihi (Bitiş)",
                accessor: "max_receivedDate",
                type: "datetime",
                operator: "<=",
            },
            {
                label: "Pusula Tarihi (Başlangıç)",
                accessor: "min_documentIssueDate",
                type: "date",
                operator: ">=",
                initialValue: this.createInitialDate()
            },
            {
                label: "Pusula Tarihi (Bitiş)",
                accessor: "max_documentIssueDate",
                type: "date",
                operator: "<=",
                initialValue: this.createInitialDate()
            },
            {
                label: "Tutar(Min)",
                accessor: "min_invoiceTotal",
                type: "decimalText",
                operator: ">="
            },
            {
                label: "Tutar(Max)",
                accessor: "max_invoiceTotal",
                type: "decimalText",
                operator: "<="
            },
            {
                label: "Alıcı Kişi",
                accessor: "destinationPname",
                type: "text",
                operator: "=",
            },
            {
                label: "Pusula Türü",
                accessor: "invoiceTypeCode",
                type: "select",
                operator: "=",
                selectData: this.archiveInvoiceTypesSelectData()
            },
            {
                label: "İptal Durumu",
                accessor: "cancelled",
                type: "select",
                operator: "=",
                selectData: [
                    {value: null, label: "Tümü"},
                    {value: "0", label: "İptal Edilmeyenler"},
                    {value: "1", label: "İptal Edilenler"},
                ]
            },
            {
                label: "Pusula Durumu",
                accessor: "processState",
                type: "select",
                operator: "=",
                selectData: this.invoiceStates()
            },
            {
                label: "İşaret Adı",
                accessor: "tagList",
                type: "select",
                operator: "=",
                selectData: this.state.tagList
            },
            {
                label: "Yazdırılma Durumu",
                accessor: "isPrinted",
                type: "select",
                operator: "=",
                selectData: [
                    {value: null, label: "Tümü"},
                    {value: "0", label: "Yazdırılmamış"},
                    {value: "1", label: "Yazdırılmış"}
                ]
            },
            {
                label: "E-posta Durumu",
                accessor: "emailSent",
                type: "select",
                operator: "=",
                selectData: [
                    {value: null, label: "Tümü"},
                    {value: "3", label: "Hatalı"},
                    {value: "1", label: "Hatasız"},
                    {value: "0", label: "Gönderim Bekliyor"}

                ]
            },
            this.props.currentUser.isAdminUser ?
            {
                label: "Pusulayı Oluşturan",
                accessor: "sourceUser",
                type: "select",
                operator: "=",
                selectData: this.state.userNameList
            } : {}
        ];
        let fieldsTitck = [
            {
                label: "Evrak No",
                accessor: "titckEvrakNo",
                type: "text",
                operator: "=",
                selectData: this.state.tagList
            },
            {
                label: "İşlem No",
                accessor: "titckIslemNo",
                type: "text",
                operator: "=",
                selectData: this.state.tagList
            },
            {
                label: "Referans No",
                accessor: "titckReferansNo",
                type: "text",
                operator: "=",
                selectData: this.state.tagList
            },
            {
                label: "Müracaat Tarihi (Başlangıç)",
                accessor: "titckMuraacatTarihi",
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Müracaat Tarihi (Bitiş)",
                accessor: "titckMuraacatTarihi",
                type: "datetime",
                operator: "<=",
            }
        ];
        if (this.props.currentUser.vknTckn === "8790638644") {
            for (let i = 0; i < fieldsTitck.length; i++)
                fields.push(fieldsTitck[i]);
        }

        return (
            <div className="row baseBackground">
                <div>
                    <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}
                              btnDisabled={this.state.btnDisabled}
                              selection={this.state.selection} name='archiveInvoiceList'>

                        <StickButton position="leftSide"
                                     label={((this.state.isArchive !== 1) ? "Tümünü Arşivle" : "Tümünü Arşivden Çıkar")}
                                     selection={this.state.selection}
                                     disabled={this.state.btnDisabled || this.state.isArchive === 2 || this.state.content.length === 0 || !hasUserRight(UserRightsEnum.newExpenseNote.update, this.props.currentUser)}
                                     title={((this.state.isArchive !== 1) ? "Tümünü Arşivle" : "Tümünü Arşivden Çıkar")}
                                     onClick={(e) => this.setStatus(e, (this.state.isArchive !== 1 ? 1 : 0), "allArchive")}
                                     className="stickButton archive" icon='archive'/>

                        <StickButton position="leftSide"
                                      label={this.state.isArchive !== 1 ? 'Seçilenleri Arşivle' : 'Seçilenleri Arşivden Çıkar'}
                                      title={this.state.isArchive !== 1 ? 'Seçilenleri Arşivle' : 'Seçilenleri Arşivden Çıkar'}
                                      className={this.state.isArchive !== 1 ? 'stickButton archive' : "stickButton upload"}
                                      onClick={this.state.isArchive !== 1 ? (e) => this.setStatus(e, 1, "isArchive") : (e) => this.setStatus(e, 0, "isArchive")}
                                      selection={this.state.selection}
                                      btnDisabled={this.state.btnDisabled || !hasUserRight(UserRightsEnum.newExpenseNote.update, this.props.currentUser)}
                                      disabled={this.state.btnDisabled || this.state.selection.length === 0}/>

                        {hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) && showExcelExport(EntegratorConf.identifier) && isCreditSufficient &&
                        <ExcelExporter position="leftSide" url='/newExpenseNote/exportXls' sheetName='Gider Pusulalar'
                                       content={this.state.content} title="Excel'e Aktar"
                                       customSheetNameUrl='newExpenseNote/findFirstAndLast'
                                       selection={this.state.selection} onClick={() => this.exportXls()}
                                       defaultHeaders={defaultHeaders} customHeaders={this.state.customHeaders}
                                       customExport={true} year={this.state.year.value}
                                       openCustomizerModal={this.openCustomizerModal}
                                       clearCustomHeaders={this.clearCustomHeaders}
                                       btnDisabled={this.state.selection.length === 0 || this.state.btnDisabled}
                                       type='expenseNote' clearSelection={this.clearSelection}
                                       stateCodes={this.state.stateCodes}
                                       triggerDownloadRequestTooltip={this.props.triggerDownloadRequestTooltip}
                                       icon='excel'/>
                        }

                        <SquareButton
                            position='leftSide'
                            title='Tek Pdf İndir'
                            selection={this.state.selection}
                            imgStyle={{width: '19px', marginBottom: '5px'}}
                            fontAwesomeClass={this.state.loadingObj.singlePdfLoading ? "fas fa-spinner fa-spin" : "far fa-file-pdf"}
                            disabled={this.state.selection.length === 0 || this.state.btnDisabled || !hasUserRight(UserRightsEnum.newExpenseNote.viewIncoming, this.props.currentUser)}
                            onClick={() => {
                                if (!this.state.btnDisabled && this.state.selection.length > 0) {
                                    this.downloadLink('singlePdf');
                                }
                            }}
                        />

                        <SquareButton
                            position='leftSide'
                            title='Toplu Pdf İndir'
                            fontAwesomeClass={this.state.loadingObj.lotsPdfLoading ? "fas fa-spinner fa-spin" : "fa fa-file-pdf"}
                            selection={this.state.selection}
                            disabled={this.state.btnDisabled || !hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser)}
                            onClick={() => {
                                if (!this.state.btnDisabled && this.state.selection.length > 0) {
                                    this.downloadLink('pdfZip');
                                }
                            }}
                        />

                        <SquareButton
                            position="leftSide"
                            title='Tek Pdf İndir (GİB XSLT)'
                            fontAwesomeClass={this.state.loadingObj.singleLoadingXSLT ? "fas fa-spinner fa-spin" : "far fa-file-alt"}
                            selection={this.state.selection}
                            disabled={this.state.btnDisabled || !hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser)}
                            onClick={() => {
                                if (!this.state.btnDisabled && this.state.selection.length > 0) {
                                    this.downloadLink('gibTekPdf');
                                }
                            }}
                        />


                        <a position="leftSide"  onClick={()=>this.print("printPdf")} download title='Toplu Yazdır'
                           style={(this.state.selection.length > 0) ? {fontSize: 'inherit'} : {
                               pointerEvents: "none",
                               cursor: "default",
                               fontSize: 'inherit'
                           }}
                           disabled={this.state.selection.length === 0 || this.state.btnDisabled}
                           icon="pdf">
                            <SquareButton position="rightSide" title='Toplu Yazdır'
                                          fontAwesomeClass={this.state.printLoading?"fas fa-spinner fa-spin":"fas fa-print"}
                                          selection={this.state.selection}
                                          btnDisabled={this.state.selection.length === 0 || this.state.btnDisabled || !hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser)}/>
                        </a>


                        <SquareButton
                            position='leftSide'
                            title='Toplu Xml İndir'
                            cssIconClass={!this.state.loadingObj.lotsLoadingXML ? 'xml-icon' : undefined}
                            imgStyle={{ width: '19px', marginBottom: '10px' }}
                            style={{ minWidth: '40px', position: 'relative' }}
                            selection={this.state.selection}
                            btnDisabled={
                                this.state.selection.length === 0 ||
                                this.state.btnDisabled ||
                                !(hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) ||
                                    hasUserRight(UserRightsEnum.newExpenseNote.viewIncoming, this.props.currentUser))
                            }
                            onClick={() => {
                                if (
                                    this.state.selection.length > 0 &&
                                    !this.state.btnDisabled &&
                                    (hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser) ||
                                        hasUserRight(UserRightsEnum.newExpenseNote.viewIncoming, this.props.currentUser))
                                ) {
                                    this.setState(prevState => ({
                                        loadingObj: { ...prevState.loadingObj, lotsLoadingXML: true }
                                    }));
                                    this.downloadLink('xmlZip');
                                }
                            }}
                            fontAwesomeClass={this.state.loadingObj.lotsLoadingXML ? "fas fa-spinner fa-spin" : ""}
                        />

                        <SquareButton position="leftSide" title='Yenile'
                                      onClick={(e) => this.props.reload(true, "header")} icon='reload'/>

                        <StickButton position="leftSide" title="İşaretle"
                                     label="İşaretle"
                                     disabled={this.state.saveLoading || !hasUserRight(UserRightsEnum.newExpenseNote.update, this.props.currentUser)}
                                     className="stickButton flag"
                                     onClick={(e) => this.setState({tagingOpen: true})} icon='flag'/>


                        <ArchiveDropdownButton position="rightSide" onChangeArchive={this.onChangeArchive}
                                               isArchive={this.state.isArchive} style={{minWidth: '150px'}}/>
                    </NavBarKS>
                </div>
                <div>
                    {this.state.tagingOpen &&
                    <Tagging
                        closeClick={this.closeClick}
                        invoiceList={this.state.selectedInvoice}
                        controllerName={"newExpenseNote"}
                        tagType={7}
                        year={this.state.year.value}
                        month={this.state.month}/>
                    }
                </div>
                <div className="col-sm-12 satirBasi">
                    <div className="card-header">
                        <h4 className="card-title">{'E-Gider Pusulalar ' + this.state.year.label}</h4>
                    </div>

                    <div className="card-body" style={{paddingBottom: '0px'}}>
                        <div className="">
                            <div className="" style={{marginTop: '10px', marginBottom: '0px'}}>
                                <DetailedSearch fields={setFields(fields)}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch}
                                                toggle={this.detailSearchToggle}
                                                filterType="newExpenseNote"
                                                filterSearch={true}/>
                            </div>
                        </div>
                    </div>

                    <div className="row col-sm-12" style={{marginLeft: '10px', paddingLeft: "5px"}}>
                        <p className="text-warning"
                           style={{margin: '0px', padding: "0px"}}>*İşleniyor&nbsp;&nbsp;</p>
                        <p className="text-success"
                           style={{margin: '0px', padding: "0px"}}>*Başarılı&nbsp;&nbsp;</p>
                        <p className="text-danger" style={{margin: '0px', padding: "0px"}}>*Hatalı</p>
                    </div>

                    <div className="col-sm-12">
                        <YearPicker years={this.state.years}
                                    selectedYear={this.state.year.value}
                                    selectedMonth={this.state.month}
                                    selectedYearLabel={this.state.year.label}
                                    onSetYear={this.setYear}
                                    onSetMonth={this.setMonth}
                                    loading={this.state.loading}
                                    type={ "fulldate"}/>

                    </div>

                    <div className="col-sm-12">
                        <Table columns={source === 'vega' ? vegaColumns : columns}
                               loading={this.state.loading}
                               loadingText="Kayıtlar getiriliyor..."
                               content={this.state.content}
                               total={this.state.total}
                               page={this.state.page}
                               manual={this.state.manual}
                               size={this.state.size}
                               options={["5", "10", "20", "50", "100", "250"]}
                               fetchData={this.fetchData}
                               getTrStyles={this.getTrStyles}
                               jumberEnabled={true}
                               topPagination={this.state.size >= 20 && this.state.total >= 20}
                        />
                    </div>

                </div>

                {this.state.expenseNoteModal &&
                <ExpenseNoteModal
                    documentUuid={this.state.documentUuid}
                    toggleModal={(flag) => this.setState({expenseNoteModal: flag})}
                    modal={this.state.expenseNoteModal}/>
                }

                {this.state.mailModal &&
                <SendInvoiceMailModal
                    year={this.state.year.value}
                    month={this.state.month}
                    type="expenseNote"
                    selected={this.state.selected}
                    toggleModal={(flag) => this.setState({mailModal: flag})}
                    postUrl="/mail/sendMail"
                    mailModal={this.state.mailModal}/>
                }

                {this.state.mediaModal &&
                <MediaViewer modal={this.state.mediaModal}
                             url={this.state.url}
                             title={this.state.title}
                             listener={this.setMediaViewer}
                             selectedItem={this.state.selectedItem}
                             selectedIndex={this.state.selectedIndex}
                             currentUser={this.props.currentUser}
                             location='newExpenseNote'
                             stateCodes={this.state.stateCodes}
                             downloadMedia={this.downloadMedia}
                             cancelInvoice={this.cancelExpenseNoteFromViewer}
                             revertCancelInvoice={this.revertCancelExpenseNoteFromViewer}
                             copyEditInvoice={this.copyEditExpenseNote}
                             sendEmail={this.sendEmailFromViewer}
                             showExpenseNote={this.props.showExpenseNote}
                             createExpenseNote={this.createExpenseNoteFromViewer}
                />
                }

                {(this.state.printModal && this.state.url) &&
                <PrintViewer url={this.state.url} close={this.closePrintModal}/>
                }

                {this.state.showCancelModal &&
                <DefaultModal
                    disabled={this.state.cancelBtnDisabled}
                    isOpen={this.state.showCancelModal}
                    title={"Pusula İptal Et (" + this.state.selectedItem.documentId + ")"}
                    confirmBtnText="Gönder"
                    cancelBtnText="Kapat"
                    onConfirm={this.renderDateConfirmError}
                    onCancel={(e) => this.setState({showCancelModal: false, cancelReason: "", cancelTime: ""})}
                >
                    <div className="row" style={{marginTop: 20, position: 'relative'}}>
                        <div className="col-12">
                            <div className={"form-group" + this.validateClass('cancelReason')}>
                                <label className="col-form-label">İptal Sebebi</label>
                                <input className="form-control"
                                       type="text"
                                       onChange={this.onChangeReason}
                                       value={this.state.cancelReason || ""}
                                       name="cancelReason"/>
                                {this.validateMessage('cancelReason') !== "" &&
                                <UncontrolledTooltip placement="right" target="cancelReason" delay={0}>
                                    {this.validateMessage("cancelReason")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>
                        <div className="col-12">
                            <div className={"form-group" + this.validateClass('cancelTime')}>
                                <label className="col-form-label">İptal Zamanı</label>
                                <Datetime locale="tr"
                                          input={true}
                                          onBlur={(momentObj) => this.validateField({
                                              target: {
                                                  id: "cancelTime",
                                                  dataset: {'vdata': "datetime"},
                                                  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                              }
                                          })}
                                          inputProps={{id: 'cancelTime'}}
                                          closeOnSelect={false}
                                          closeOnTab={false}
                                          value={moment(this.state.cancelTime, "YYYY-MM-DD HH:mm:ss", true).isValid() ?
                                              moment(this.state.cancelTime).format("DD-MM-YYYY HH:mm:ss") :
                                              this.state.cancelTime}
                                          dateFormat="DD-MM-YYYY"
                                          timeFormat="HH:mm:ss"
                                          isValidDate={(current) => this.checkDateValidity(current, 'cancelTime')}
                                          onChange={(e) => this.onChangeValue({
                                              target: {
                                                  name: "cancelTime",
                                                  value: e
                                              }
                                          })}/>
                                {this.validateMessage('cancelTime') !== "" &&
                                <UncontrolledTooltip placement="right" target="cancelTime" delay={0}>
                                    {this.validateMessage("cancelTime")}
                                </UncontrolledTooltip>
                                }
                            </div>
                        </div>
                    </div>
                </DefaultModal>
                }

                {this.state.showRevertCancelModal &&
                <DefaultModal
                    disabled={this.state.cancelBtnDisabled}
                    isOpen={this.state.showRevertCancelModal}
                    title={"Pusula İptalini Geri Al (" + this.state.selectedItem.documentId + ")"}
                    confirmBtnText="Onayla"
                    cancelBtnText="Kapat"
                    onConfirm={this.confirmRevertCancelExpenseNote}
                    onCancel={(e) => this.setState({showRevertCancelModal: false})}
                >
                    <div className="row" style={{marginTop: 20, marginBottom: 20, position: 'relative'}}>
                        <div className="col-12">
                            <label className="col-form-label" style={{fontSize: "14px", fontWeight: "bold"}}>Pusula
                                iptal işlemi geri alınacaktır. Onaylıyor musunuz?</label>
                        </div>
                    </div>
                </DefaultModal>
                }


            </div>
        );
    }
}

export default NewExpenseNote;
